import {RootState} from "../store";

export const allOrdersSelector = (state: RootState) => state.allOrders.orders;

export const totalSelector = (state : RootState) => state.allOrders.total;
export const totalTodaySelector = (state : RootState) => state.allOrders.totalToday;